'use client'

import { Box, Stack, Text } from '@chakra-ui/react'
import Products from './_components/Products'
import Bill from './_components/Bill'
import { useTranslations } from 'next-intl'
import { sessionActions } from '@/_store/session/session.slice'
import { useDispatch, useSelector } from 'react-redux'
import { SegmentedControl } from '@/components/ui/segmented-control'
import { IRedux } from '@/_store/types'
import { useParams } from 'next/navigation'
import getSiteSettings from '@/_service/settings.service'
import { useQuery } from '@tanstack/react-query'
import { useCustomLocale } from '@/shared/hooks/use-custom-locale'
import { onOpenMap } from '@/_store/common/common.slice'
import { resolveBrandId } from '@/_lib/brand-href'

export default function CartPage() {
  const params = useParams<{ brandSlug?: string; id?: string }>()
  const t = useTranslations()
  const dispatch = useDispatch()
  const currentLocale = useCustomLocale()
  const { order_type } = useSelector((state: IRedux) => state.session)

  const shipperId = resolveBrandId(params?.brandSlug || params?.id || '')

  // Source settings query
  const { data: webSettings } = useQuery({
    queryKey: ['web-settings', shipperId],
    queryFn: () => getSiteSettings(shipperId),
    select: (res) => res?.data,
    enabled: Boolean(shipperId),
  })

  const orderTypes = webSettings?.order_types || []

  // Handle order type change
  const handleOrderTypeChange = (value: string) => {
    const selectedType = orderTypes.find((item) => item.id === value)
    if (selectedType) {
      dispatch(sessionActions.saveOrderType(selectedType))
      if (selectedType.type === 'self-pickup') dispatch(onOpenMap())
    }
  }

  return (
    <Stack gap={0} bg='white' rounded={16} height='calc(100dvh - 140px)'>
      <Text fontWeight={700} fontSize={18} p={4} pb={2}>
        {t('cart')}
      </Text>
      <Box px={4} pb={2}>
        {orderTypes?.length > 0 && (
          <SegmentedControl
            size='lg'
            w='full'
            height='48px'
            fontWeight={600}
            value={order_type?.id}
            onValueChange={(e: any) => handleOrderTypeChange(e.value)}
            items={orderTypes?.map((item) => ({
              label: item?.name?.[currentLocale] || '',
              value: item.id,
            }))}
          />
        )}
      </Box>
      <Box flex={1} overflowY='auto'>
        <Products />
      </Box>
      <Box pt={2} p={4}>
        <Bill />
      </Box>
    </Stack>
  )
}
